<template>
    <VForm
        v-slot="validation"
        @submit="onSubmit">
        <div class="grid sm:grid-cols-1 gap-6">
            <div>
                <BaseSelect
                    id="year"
                    v-model="yearId"
                    label="Jahr auswählen"
                    name="select_year"
                    display-key="id"
                    :options="selectableYears"
                    rules="required"
                    required />
                <Alert
                    v-if="selectableYears.length === 0"
                    class="mt-4"
                    type="info">
                    Für den Förderbereich dieser Maßnahme ist in keinem Jahr die Erstellung neuer Maßnahmen aktiviert.
                </Alert>
            </div>
            <div>
                <BaseInput
                    v-model="newEvent.name"
                    :label="$t('processes.copy.eventName')"
                    :placeholder="$t('processes.copy.eventName')"
                    required
                    :rules="{max: 255, required:true}" />
            </div>
        </div>
        <BaseSubmitButtons
            :submit-label="$t('processes.copy.copyProcess')"
            :loading="loading"
            :validation="validation"
            @cancel="slideOverStore.resetSlideOver()" />
    </VForm>
</template>

<script setup>
import {useNuxtApp} from "nuxt/app"
import {useStatic} from "@/store/static"
import {$lara} from '@/utils/$larafetch'
import {useNotification} from "~/composables/useNotification"
import {useProcessGroupsStore} from "~/store/processGroups"
import {useSlideOverStore} from "~/store/slideOver"

const staticStore = useStatic()
const slideOverStore = useSlideOverStore()
const {$apiRoute} = useNuxtApp()
const notification = useNotification()
const app = useNuxtApp()
const {t: $t} = useI18n()
const useProcessGroups = useProcessGroupsStore()

const {isProcessCreationEnabled} = useYearFundingAreas()

const loading = ref(false)
const oldEvent = computed(() => {
    return slideOverStore.context.event
})
const oldProcess = computed(() => {
    return slideOverStore.context.process
})
const fundingProgram = computed(() => {
    return slideOverStore.context.fundingProgram
})

// Copying creates a new process, so only years in which the process' funding area is enabled
const selectableYears = computed(() => (staticStore.years ?? [])
    .filter(year => isProcessCreationEnabled(year, fundingProgram.value)))

const yearId = ref(selectableYears.value.find(year => year.id === staticStore.activeYear?.id)?.id
    ?? selectableYears.value[0]?.id
    ?? null)

const newEvent = ref({
    name: oldEvent.value.name
})

function onSubmit() {
    loading.value = true
    $lara.post(
        $apiRoute('spa.processes.processes.copy'), {
            body: {
                oldProcessId: oldProcess.value.id,
                yearId: yearId.value,
                newEvent: newEvent.value
            }
        }
    ).then(() => {
        slideOverStore.resetSlideOver()
        useProcessGroups.fetchProcessGroups()
        notification.success($t('processes.copy.copyProcessSuccess'))
    }).catch((error) => {
        if (error && error.response && error.response.status === 422) {
            notification.error(app.$i18n.t('invalidRequestData'))
        } else if (error && error.response && error.response.status === 404) {
            notification.error(app.$i18n.t('modelDoesNotExist'))
        } else {
            if (error && error.response?._data.message) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
            } else if ( error && error.response?._data) {
                notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
            } else {
                notification.error(app.$i18n.t('generalRequestError'))
            }
        }
    }).finally(() => {
        loading.value = false
    })
}

onMounted(() => {
    let canOccurMultiple = true

    oldProcess.value.formProcesses.forEach((formProcess) => {
        if (!formProcess.form.multiple_occurrence_in_event) {
            canOccurMultiple = false
        }
    })
})
</script>

<style scoped>

</style>